<template>
  <div class="relative" ref="dropdownRef">
    <button @click.stop="isOpen = !isOpen"
      class="flex items-center px-3 py-2 space-x-2 text-sm font-medium text-gray-700 transition-colors duration-300 hover:text-red-600 focus:outline-none">
      <img :src="currentLanguageFlag" :alt="currentLanguageText" class="w-6 h-4 rounded" />
      <span class="hidden sm:inline">{{ currentLanguageText }}</span>
      <i class="text-xs fas fa-chevron-down"></i>
    </button>

    <div v-show="isOpen"
      class="overflow-y-auto absolute right-0 z-50 py-1 mt-2 w-56 max-h-96 bg-white rounded-md shadow-lg animate-fadeIn">
      <button v-for="lang in languages" :key="lang.code" @click.stop="switchLanguage(lang.code)"
        class="flex items-center px-4 py-3 space-x-3 w-full text-sm text-left text-gray-700 transition-colors duration-300 hover:bg-gray-100 hover:text-red-600">
        <img :src="`/language/${lang.code}.png`" :alt="lang.name" class="w-8 h-6 rounded" />
        <div class="flex flex-col">
          <span class="font-medium">{{ lang.name }}</span>
          <span class="text-xs text-gray-500">{{ lang.nativeName }}</span>
        </div>
      </button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'LanguageSelector',
  data() {
    return {
      isOpen: false,
      languages: [
        { code: 'en', name: 'English', nativeName: 'English' },
        { code: 'ru', name: 'Russian', nativeName: 'Русский' },
        { code: 'ar', name: 'Arabic', nativeName: 'العربية' },
        { code: 'es', name: 'Spanish', nativeName: 'Español' },
        { code: 'zh', name: 'Chinese', nativeName: '中文' },
        { code: 'ko', name: 'Korean', nativeName: '한국어' },
        { code: 'ja', name: 'Japanese', nativeName: '日本語' },
        { code: 'tr', name: 'Turkish', nativeName: 'Türkçe' }
      ]
    }
  },
  computed: {
    currentLanguageText() {
      const lang = this.languages.find(l => l.code === this.$i18n.locale);
      return lang ? lang.name : 'English';
    },
    currentLanguageFlag() {
      const lang = this.languages.find(l => l.code === this.$i18n.locale);
      return lang ? `/language/${lang.code}.png` : '/language/en.png';
    }
  },
  watch: {
    isOpen(newVal) {
      if (newVal) {
        document.addEventListener('click', this.handleClickOutside);
      } else {
        document.removeEventListener('click', this.handleClickOutside);
      }
    }
  },
  beforeUnmount() {
    document.removeEventListener('click', this.handleClickOutside);
  },
  methods: {
    switchLanguage(lang) {
      this.$i18n.locale = lang;
      localStorage.setItem('language', lang);
      this.isOpen = false;
    },
    handleClickOutside(event) {
      if (this.$refs.dropdownRef && !this.$refs.dropdownRef.contains(event.target)) {
        this.isOpen = false;
      }
    }
  }
}
</script>

<style scoped>
@keyframes fadeIn {
  from {
    opacity: 0;
    transform: translateY(-10px);
  }

  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.animate-fadeIn {
  animation: fadeIn 0.3s ease-out forwards;
}
</style>